/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Styles
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";

// Soft UI Dashboard PRO React helper functions
import boxShadow from "assets/theme/functions/boxShadow";
import pxToRem from "assets/theme/functions/pxToRem";

const { dark, white } = colors.light;
const { borderWidth, borderColor } = borders;

const darkActive = "#17c1e8";

export default {
  styleOverrides: {
    root: ({ theme }) => {
      const isDark = theme.palette.mode === "dark";
      return {
        background: isDark ? "rgba(255,255,255,0.06)" : white.main,
        fill: isDark ? "rgba(255,255,255,0.06)" : white.main,
        stroke: isDark ? "rgba(255,255,255,0.06)" : white.main,
        strokeWidth: pxToRem(10),
        width: pxToRem(13),
        height: pxToRem(13),
        border: `${borderWidth[2]} solid ${isDark ? "rgba(255,255,255,0.22)" : borderColor}`,
        borderRadius: "50%",
        zIndex: 99,
        transition: "all 200ms linear",

        "&.Mui-active": {
          background: isDark ? darkActive : dark.main,
          fill: isDark ? darkActive : dark.main,
          stroke: isDark ? darkActive : dark.main,
          borderColor: isDark ? darkActive : dark.main,
          boxShadow: boxShadow([0, 0], [0, 2], isDark ? darkActive : dark.main, 1),
        },

        "&.Mui-completed": {
          background: isDark ? "rgba(23,193,232,0.4)" : dark.main,
          fill: isDark ? "rgba(23,193,232,0.4)" : dark.main,
          stroke: isDark ? "rgba(23,193,232,0.4)" : dark.main,
          borderColor: isDark ? darkActive : dark.main,
          boxShadow: boxShadow([0, 0], [0, 2], isDark ? darkActive : dark.main, 0.6),
        },
      };
    },
  },
};
